import script from "./groupadd.vue?vue&type=script&lang=ts&setup=true"
export * from "./groupadd.vue?vue&type=script&lang=ts&setup=true"

import "./groupadd.vue?vue&type=style&index=0&id=3f816a06&lang=scss"

const __exports__ = script;

export default __exports__